// src/components/effects/GoldButton.jsx
// Botón principal dorado metálico que late con halo (kit: UiButton + .cta-halo/.cta-palpita).
export default function GoldButton({ children, pulse = false, arrow = true, size = "md", block = false, as: Tag = "button", className = "", ...rest }) {
  const cls = ["ca-btn-gold", pulse && "ca-cta-pulse", size === "sm" && "ca-btn-sm", block && "ca-btn-block", className].filter(Boolean).join(" ");
  return (
    <Tag className={cls} {...rest}>
      {children}
      {arrow && <span className="ca-arr" aria-hidden="true">→</span>}
    </Tag>
  );
}

export function GhostButton({ children, size = "md", block = false, as: Tag = "button", className = "", ...rest }) {
  return <Tag className={["ca-btn-ghost", size === "sm" && "ca-btn-sm", block && "ca-btn-block", className].filter(Boolean).join(" ")} {...rest}>{children}</Tag>;
}
